class FsLogos extends HTMLElement {
  constructor () {
    super()

    this.elLogosList = this.querySelector('.fs-logos__list')
    this.elClonedList = this.elLogosList.cloneNode(true)
    this.mm = gsap.matchMedia()

    this.removeDuplicateElements()
    this.createDuplicateElements()
    this.setupTimeline()
    this.addEventListeners()
    this.addResizeListener()
  }

  addResizeListener () {
    const onResize = () => {
      this.removeDuplicateElements()
      this.clearTimeline()

      this.createDuplicateElements()
      this.setupTimeline()
    }

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(onResize, 100)
    })
  }

  createDuplicateElements () {
    this.elLogosList = this.elClonedList.cloneNode(true)
    this.appendChild(this.elLogosList)

    const duplicatesCount = Math.ceil(window.innerWidth / this.elLogosList.offsetWidth)

    this.elsDuplicates = Array.from({ length: duplicatesCount }, () => this.elClonedList.cloneNode(true))

    this.elsDuplicates.forEach((elDuplicate) => {
      elDuplicate.classList.add('fs-logos__list--duplicate')
      this.appendChild(elDuplicate)
    })
  }

  removeDuplicateElements () {
    this.innerHTML = ''
  }

  setupTimeline () {
    const duration = this.elLogosList.offsetWidth / 50

    this.mm.add('(prefers-reduced-motion: no-preference)', () => {
      this.tl = gsap.timeline({ repeat: -1 })
        .to([this.elLogosList, this.elsDuplicates], { x: () => -this.elLogosList.offsetWidth, duration, ease: 'none' })
    })
  }

  clearTimeline () {
    if (this.tl) {
      this.tl.kill()
    }
  }

  addEventListeners () {
    this.addEventListener('mouseenter', () => {
      if (this.tl) {
        gsap.to(this.tl, { timeScale: 0.1 })
      }
    })

    this.addEventListener('mouseleave', () => {
      if (this.tl) {
        gsap.to(this.tl, { timeScale: 1 })
      }
    })
  }
}

if (!customElements.get('fs-logos')) {
  customElements.define('fs-logos', FsLogos)
}
